import script from "./custVirtualMan.vue?vue&type=script&setup=true&lang=ts"
export * from "./custVirtualMan.vue?vue&type=script&setup=true&lang=ts"

import "./custVirtualMan.vue?vue&type=style&index=0&id=52fa6b06&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52fa6b06"]])

export default __exports__